import httpClient from 'src/http-client';
import User from 'src/models/user';

const getUser = async () => {
  return (await httpClient.get<User>(`/users/me`)).data;
};

export { getUser };
